const RESULT_CONTENT = 'content';
const OPTION_ID = 'id';
const OPTION_LABEL = 'label';
const OPTION_PATH = 'path';

const MAPPED_OPTION_LABEL = 'label';
const MAPPED_OPTION_VALUE = 'value';

export const EMPTY_RESULT_RESPONSE = {[RESULT_CONTENT]: []};

export class AutocompleteOption {
  static getHierarchyNodeId(type, id) {
    return type + (id ? `_${id}` : '');
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  getId() {
    // ignore option id, return label as id
    return this.rawData[OPTION_PATH] || '';
  }

  getLabel() {
    return this.rawData[OPTION_LABEL] || '';
  }

  getRawData() {
    return this.rawData;
  }
}

export class AutocompleteMappedOption {
  constructor(option) {
    this.option = option;
    this[MAPPED_OPTION_LABEL] = this.option.getLabel();
    this[MAPPED_OPTION_VALUE] = this.option.getId();
  }

  getLabel() {
    return this[MAPPED_OPTION_LABEL];
  }

  getValue() {
    return this[MAPPED_OPTION_VALUE];
  }
}

export class AutocompleteResult {
  static instantiateFromArrayOfValues(values) {
    const rawData = {[RESULT_CONTENT]: []};
    if (values) {
      rawData[RESULT_CONTENT] = values.map((value) => ({
        [OPTION_LABEL]: value,
        [OPTION_ID]: value,
      }));
    }
    return new AutocompleteResult(rawData);
  }

  static initOptions(rawDataOptions) {
    const options = [];
    if (rawDataOptions && rawDataOptions.length > 0) {
      rawDataOptions.forEach((option) => {
        options.push(new AutocompleteOption(option));
      });
    }
    return options;
  }

  static initMappedOptions(rawDataOptions) {
    const options = [];
    if (rawDataOptions && rawDataOptions.length > 0) {
      rawDataOptions.forEach((option) => {
        options.push(new AutocompleteMappedOption(option));
      });
    }
    return options;
  }

  constructor(rawData = []) {
    this.rawData = {...rawData};
    this.options = AutocompleteResult.initOptions(this.rawData[RESULT_CONTENT]);
    this.mappedOptions = AutocompleteResult.initMappedOptions(this.options);
  }

  getOptions() {
    return this.options;
  }

  getMappedOptions() {
    return this.mappedOptions;
  }
}

export default {
  AutocompleteResult,
  AutocompleteOption,
  AutocompleteMappedOption,
};
